import { BracketsCurlyIcon, MagicWandIcon, PlusIcon } from "@phosphor-icons/react";

import Icon from "@gx/dls/icons/Icon";
import { ProjectMappingMethod } from "@gx/ts-contracts/services/project/resources/project_configuration/project_configuration_pb";

export const AVAILABLE_MAPPING_METHODS: ProjectMappingMethod[] = [
  ProjectMappingMethod.AUTO,
  ProjectMappingMethod.JSON,
  ProjectMappingMethod.BLANK,
];

export const MAPPING_METHOD_TO_LABEL_MAP: Record<ProjectMappingMethod, string> = {
  [ProjectMappingMethod.UNSPECIFIED]: "—",
  [ProjectMappingMethod.AUTO]: "Auto-introspect",
  [ProjectMappingMethod.JSON]: "JSON",
  [ProjectMappingMethod.BLANK]: "Blank",
};

export const MAPPING_METHOD_TO_DESCRIPTION_MAP: Record<ProjectMappingMethod, string> = {
  [ProjectMappingMethod.UNSPECIFIED]: "—",
  [ProjectMappingMethod.AUTO]: "We'll analyze your data and auto-generate unified models",
  [ProjectMappingMethod.JSON]: "Paste in your JSON to build your semantic model",
  [ProjectMappingMethod.BLANK]: "Build your ontology from scratch with a canvas experience",
};

export const MAPPING_METHOD_TO_IS_RECOMMENDED_MAP: Record<ProjectMappingMethod, boolean> = {
  [ProjectMappingMethod.UNSPECIFIED]: false,
  [ProjectMappingMethod.AUTO]: true,
  [ProjectMappingMethod.JSON]: false,
  [ProjectMappingMethod.BLANK]: false,
};

export const MAPPING_METHOD_TO_ICON_MAP: Record<ProjectMappingMethod, React.ReactNode> = {
  [ProjectMappingMethod.UNSPECIFIED]: <></>,
  [ProjectMappingMethod.AUTO]: <Icon component={MagicWandIcon} size={14} />,
  [ProjectMappingMethod.JSON]: <Icon component={BracketsCurlyIcon} size={14} />,
  [ProjectMappingMethod.BLANK]: <Icon component={PlusIcon} size={14} />,
};
